import { Icon } from "@/components/icon";
import type { NavProps } from "@/components/nav";

export const navData: NavProps["data"] = [
	{
		name: "sys.menu.management",
		items: [
			{
				title: "merchantManagement",
				path: "/pw_management/merchant",
				icon: <Icon icon="material-symbols:storefront" size={24} />,
				children: [
					{
						title: "merchantList",
						path: "/pw_management/merchant",
					},
				],
			},
			{
				title: "walletsManagement",
				path: "/pw_management/wallets",
				icon: <Icon icon="material-symbols:account-balance-wallet" size={24} />,
				children: [
					{
						title: "wallets.walletList",
						path: "/pw_management/wallets",
					},
				],
			},
			{
				title: "rateManagement",
				path: "/pw_management/rate",
				icon: <Icon icon="material-symbols:currency-exchange" size={24} />,
				children: [
					{
						title: "rateList",
						path: "/pw_management/rate",
					},
				],
			},
			{
				title: "posEventManagement",
				path: "/pw_management/pos_event",
				icon: <Icon icon="material-symbols:calendar-clock" size={24} />,
				children: [
					{
						title: "posEventList",
						path: "/pw_management/pos_event",
					},
				],
			},
			{
				title: "fiatDistribution.title",
				path: "/pw_management/fiat_distribution",
				icon: <Icon icon="material-symbols:paid" size={24} />,
				children: [
					{
						title: "fiatDistribution.list",
						path: "/pw_management/fiat_distribution",
					},
					{
						title: "fiatDistribution.payoutGatewayBalance",
						path: "/pw_management/payout_gateway_balances",
					},
				],
			},
			{
				title: "withdrawalOrder.title",
				path: "/pw_management/withdrawal_orders",
				icon: <Icon icon="mingcute:bank-card-line" size={24} />,
				children: [
					{
						title: "withdrawalOrder.list",
						path: "/pw_management/withdrawal_orders",
					},
				],
			},
		],
	},
];
